import { HygraphWearable } from '@repo/types-client';

const globScrapValueMap: { [key: string]: number } = {
  Essential: 15,
  Exclusive: 150,
  Grail: 750,
  iconic: 15000,
};

/**
 * Retrieves the scrap value for a given tier.
 * @function getScrapValueForTier
 * @param {string} tier - The tier of the wearable.
 * @returns {number} The scrap value associated with the tier.
 */
export const getScrapValueForTier = (tier: string): number => {
  const wearableTierScrapValue = globScrapValueMap[tier];
  if (!wearableTierScrapValue) {
    console.error(`Invalid tier: ${tier}`);
    return 0;
  }
  return wearableTierScrapValue;
};

/**
 * Resolves the base scrap value for a wearable template.
 * @function resolveWearableTemplateBaseScrapValue
 * @param {HygraphWearable} wearable - The wearable object.
 * @returns {number} The base scrap value of the wearable.
 */
const resolveWearableTemplateBaseScrapValue = (
  wearable: HygraphWearable,
): number => {
  if (wearable.globAwardOverride) {
    return wearable.globAwardOverride;
  }

  return getScrapValueForTier(wearable.tier as string);
};

/**
 * Calculates the total scrap value for a wearable.
 * @function calculateWearableScrapValue
 * @param {HygraphWearable} wearable - The wearable object.
 * @param {number} [trimBonusMultiplier] - The optional trim bonus multiplier.
 * @returns {number} The total scrap value of the wearable.
 */
export const calculateWearableScrapValue = (
  wearable: HygraphWearable,
  trimBonusMultiplier?: number,
): number => {
  let templatePoint = resolveWearableTemplateBaseScrapValue(wearable);

  if (trimBonusMultiplier) {
    templatePoint = templatePoint * trimBonusMultiplier;
  }

  return templatePoint;
};
